import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export const Navigator = () => {
    const { t } = useTranslation();
    // Null until loaded, so the placeholder follows the language rather than being frozen
    // into state in whichever language the page first rendered in.
    const [softwareVersion, setSoftwareVersion] = useState(null);
    const [releaseDate, setReleaseDate] = useState('');
    const [releaseNotes, setReleaseNotes] = useState([]);

    useEffect(() => {
        const loadVersion = async () => {
            const response = await fetch('api/navigator/version');
            const data = await response.text();
            let parts = data.split('\n');
            if (parts.length > 1) {
                setSoftwareVersion(parts[0]);
                setReleaseDate(parts[1]);
                var releaseLines = parts.slice(2);
                //for (var i = 0; i < releaseLines.length; i++) {
                //    releaseLines[i] = releaseLines[i].replace('\t', < pre >&#9;</pre >);
                //}
                setReleaseNotes(releaseLines);
            }
        }
        loadVersion();
    }, []);

    return (
        <div>
            <div className="container">
                <div className="row">
                    <h1>Navigator</h1>
                </div>
                <div className="row">
                    <div className="col-md">
                        <div className="card">
                            <div className="card-header">
                                <h3>{t('downloads.desktopApplication')}</h3>
                            </div>
                            <div className="card-body">
                                <h4>{t('downloads.versionLabel')} {softwareVersion ?? t('downloads.loadingVersion')}</h4>
                                <h4>{t('downloads.releasedLabel')} {releaseDate}</h4>
                                <h4>{t('downloads.releaseNotesLabel')}</h4>
                                <ul className="no-bullets">
                                    {releaseNotes.map((note, index) => (
                                        <li key={index}>{note.replace('\t', ' - ')}</li>
                                    ))}
                                </ul>
                                <a href="api/navigator/download" target="_blank" rel="noopener noreferrer"><button className="btn btn-light">{t('common.download')}</button></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
